import {AssetIssueCode, BookingIssueCode} from "./types.ts";

const EURO_FORMATTER = new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
});

export function formatCents(cents: number): string {
    return EURO_FORMATTER.format(cents / 100);
}

const BOOKING_ISSUE_LABELS: Record<BookingIssueCode, string> = {
    PARSE_ERROR: "Kan boeking niet lezen",
    MISSING_AUDIT_REASON: "Omschrijving is verplicht",
    UNBALANCED: "Debet en credit zijn niet in balans",
    TOO_FEW_LINES: "Minder dan twee boekingsregels",
    INVALID_LINE: "Een regel heeft zowel debet als credit",
};

const ASSET_ISSUE_LABELS: Record<AssetIssueCode, string> = {
    PARSE_ERROR: "Kan bedrijfsmiddel niet lezen",
    RESIDUAL_EXCEEDS_PURCHASE: "Restwaarde mag niet hoger zijn dan de aanschafwaarde",
    PURCHASE_DATE_IN_FUTURE: "Aanschafdatum ligt in de toekomst",
};

export function bookingIssueLabel(code: BookingIssueCode): string {
    return BOOKING_ISSUE_LABELS[code];
}

export function assetIssueLabel(code: AssetIssueCode): string {
    return ASSET_ISSUE_LABELS[code];
}
